"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var getBorderColor = function getBorderColor(_ref) {
  var error = _ref.error,
    disabled = _ref.disabled,
    isFocused = _ref.isFocused,
    color = _ref.color;
  if (error) return color.validation.error;
  if (disabled) return color.gray.charlie;
  if (isFocused) return color.secondary;
  return color.gray.bravo;
};
var StyledSearchable = _styledComponents["default"].label.withConfig({
  displayName: "Searchablestyle__StyledSearchable",
  componentId: "sc-1a9pduv-0"
})(["", ";"], function (props) {
  var _props$theme = props.theme,
    color = _props$theme.palette,
    spacing = _props$theme.spacing;
  var value = props.value,
    error = props.error,
    disabled = props.disabled,
    searchIcon = props.searchIcon,
    isFocused = props.isFocused,
    isNumeric = props.isNumeric,
    isFullWidth = props.isFullWidth;
  var fieldWidth = isFullWidth ? '100%' : '200px';
  var inputWidth = isFullWidth ? '100%' : 'auto';
  return (0, _styledComponents.css)(["display:inline-block;border-bottom:1px solid ", ";cursor:text;position:relative;height:36px;width:", ";padding-left:", ";i{top:0px;right:6px;pointer-events:none;}span{padding:1px;font-weight:normal;}.input-component{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", " input{background-color:transparent;border-bottom:0;padding-left:0;text-overflow:ellipsis;width:", ";}}.rule-formula{position:absolute;background-color:transparent;padding:0 0 ", ";width:", ";&.no-placeholder{width:2px;}", ";}", ";"], getBorderColor({
    error: error,
    disabled: disabled,
    isFocused: isFocused,
    color: color
  }), fieldWidth, spacing.tiny, isFullWidth && (0, _styledComponents.css)(["width:100%;"]), isFocused && isNumeric ? '67%' : inputWidth, spacing.small, fieldWidth, searchIcon && (0, _styledComponents.css)(["padding-right:", ";"], spacing.large), value && (0, _styledComponents.css)(["&.user-focused .formula-value{background-color:", ";}"], color.gray.delta));
});
StyledSearchable.displayName = 'StyledSearchable';
var _default = exports["default"] = StyledSearchable;